import { render, staticRenderFns } from "./Postulate.vue?vue&type=template&id=890e5ad6&scoped=true"
import script from "./Postulate.vue?vue&type=script&lang=ts"
export * from "./Postulate.vue?vue&type=script&lang=ts"
import style0 from "./Postulate.vue?vue&type=style&index=0&id=890e5ad6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890e5ad6",
  null
  
)

export default component.exports